import Analytics from "./Analytics";

const isServer = typeof window === "undefined";

/** The application's single instance: plugins join it once the user consents */
export const analytics = new Analytics({
    app: "simplonline",
    disabled: isServer,
    environment: process.env.ENV || "local",
    build: process.env.BUILD,
    version: process.env.VERSION || "none",
});
